export const GET_SAMPLE_NOTIFY = 'GET_SAMPLE_NOTIFY'
